// 언어 코드는 여기 한 곳에서만 해석한다.
// 앱 안 언어값: ko / en / jp (문구 파일 이름과 같다). 화면(html lang) 언어값: ko / en / ja.
const APP_LANGS = ["ko", "en", "jp"]
const ALIASES = { kr: "ko", kor: "ko", eng: "en", ja: "jp", jpn: "jp" }

// 브라우저 언어(ja-JP), 주소의 ?lang=ja, 저장된 값 등을 앱 언어값으로 바꾼다. 모르는 값이면 null.
export function normalizeLang(value) {
  const code = String(value || "").trim().toLowerCase().split(/[-_]/)[0]
  const lang = ALIASES[code] || code
  return APP_LANGS.includes(lang) ? lang : null
}

export function domLang(lang) {
  const normalized = normalizeLang(lang) || "ko"
  return normalized === "jp" ? "ja" : normalized
}

export function applyDocumentLang(lang) {
  if (typeof document !== "undefined") document.documentElement.lang = domLang(lang)
}
